<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>{{ pageTitle }}</h3>
      <hr>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput" >

        <div
          slot="jt-form-slot-sectionProductSubscriptionLease">
          <PagePLPaymentPlanChangeFormLease
            ref="pageTableLease" />
        </div>
        
      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <button v-show="pageShowData" v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>

      <TemplateButton v-show="hasAddOrEditPermission() && pageShowSumbit && pageCanSubmit" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Submit Application
      </TemplateButton>

      <TemplateButton v-show="approvalShowApprove" v-on:click="onApproveButtonClick" type="button" class="btn btn-danger">
        Approve
      </TemplateButton>

      <TemplateButton v-show="approvalShowComplete" v-on:click="onCompleteButtonClick" type="button" class="btn btn-danger">
        Complete
      </TemplateButton>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import PagePLPaymentPlanChangeFormLease from "@/components/Page/ParkingLicense/PagePLPaymentPlanChangeFormLease";

var querystring = require('querystring');
var moment = require('moment');

const PARAM = [
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name,
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'licenseID',
    text: 'Parking License',
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
        let customer = option['_customer'];
        text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
        return text;
      },
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionProductSubscription',
    form_section: 'Product Subscription',
  },
  {
    key: '_lease',
    form_label_attr: { style: 'display:none'},
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        if(typeof option === 'string') {
          return option;
        }
        let text = `${option['leaseZone']} - ${option['leaseProductName']} - ${option['parkerName']} `;
        if(option['isParkAide']) {
          text += '(Passcard: ParkAide Blocked)';
          if(new moment() > helper.parseDateTime(option['commencementDate'])) {
            if(!option['isBlock']) {
              text += '(Passcard: ParkAide Active)';
            }
          }
        } else {
          text += option['leasePasscard'] ? '(Passcard: ' + option['leasePasscard'] + ')' : '';
        }
        return text;
      },
    },
    form_edit_hide: true,
    form_input_attr: { 'multiple' : true },
    form_chosen_multiple: true,
  },
  {
    key: 'sectionProductSubscriptionLease',
    form_html: () => '',
  },
  {
    key: 'paymentPlan',
    text: 'New Payment Plan',
    form_radio: [
      {1:'Monthly'}, 
      {2:'Quarterly'},
      {3:'Half-Year'},
      {4:'Annually'}
    ],
    form_muted: '<b>* The payment plan will be effective next billing cycle.</b>',
  },
  {
    key: 'applicationStaff',
    text: 'Staff Name',
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'applicationStaffNo',
    text: 'Staff No',
    form_input_attr: {
      disabled: true,
    },
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePLPaymentPlanChangeForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    PagePLPaymentPlanChangeFormLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Payment Plan Change Application', url: '/plPaymentPlanChange' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,

      pageTitle: null,
      pageShowData: false,
      pageShowSumbit: false,
      pageCanSubmit: false,

      pageStaff: null,
      pageCarpark: null,
      pageCustomer: null,
      pagePasscard: null,

      pageLicense: null,
      pageSeason: undefined,
      pageFees: {},
      pageParker: undefined,

      approvalShowApprove: false,
      approvalShowComplete: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/plPaymentPlanChange');
    });

    if(helper.checkRoleIsParker()) {
      this.PARAM_MAP['applicationStaff'].form_add_hide = true;
      this.PARAM_MAP['applicationStaff'].form_edit_hide = true;
      this.PARAM_MAP['applicationStaff'].form_input_validation = [];
      this.PARAM_MAP['applicationStaffNo'].form_add_hide = true;
      this.PARAM_MAP['applicationStaffNo'].form_edit_hide = true;
      this.PARAM_MAP['applicationStaffNo'].form_input_validation = [];
    }
    
    this.hideFormFromKey('licenseID');
    this.loadStaff();
  },
  methods: {
    hideFormFromKey(key) {
      if(key === null) {
        this.pageShowSumbit = true;
      }

      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        parameter.form_hide = hide;
      });
    },

    // 1. load staff, customer & carpark
    // 2a. if add - init application, load license, license lease
    // 2b. if edit - load application, license (specific, for customer + carpark), application data, application lease
    // 3. load leases related (parker, season, season fees)
    loadStaff() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading staff data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['applicationStaff'], response.data);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'staff data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          
          // helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark = response.data);
          // this.loadZone();

          this.pageCarpark = response.data
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
        });
    },

    loadApplication() {
      let applicationID = this.$route.query.applicationID;
      if(applicationID) {
        this.pageIsAdd = false;
        let feedbackItem = 'parking license payment plan change application info';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.SERVER_URL + '/api2/request?carparkID=' + this.$route.query.carparkID + '&applicationID=' + applicationID + '&type1=paymentPlanChange',
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            response.data = response.data.filter(k => k.createDate > 1545955200);

            let temp = response.data[0];
            let application = {};
            application['applicationID'] = temp['applicationID'];
            application['licenseID'] = temp['licenseID'];
            application['carparkID'] = temp['carparkID'];
            application['customerID'] = temp['customerID'];
            application['paymentPlan'] = temp['data1'];
            application['applicationStaff'] = temp['data2'];
            application['applicationTnC'] = 1;
            application['status'] = temp['status1'];
            application['lease'] = response.data;
            this.$refs['pageForm'].setForm(false, application);
            this.$refs['pageTableLease'].setLeaseData(application['lease'] = response.data, false);

            if(application['status'] === 'Pending Approval' || application['status'] === 'Pending') {
              this.approvalShowApprove = true;
              this.pageCanSubmit = true;
            } else if(application['status'] === 'Approved') {
              this.approvalShowComplete = true;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else {
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            }
            
            this.onApplicationStaffChange();

            this.pageTitle = 'Parking License Payment Plan Change Application ' + helper.plFormPLPPCNum(application['applicationID'], application['carparkID']);
            this.pageShowData = true;

            this.loadLicense();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      } else {
        this.pageIsAdd = true;
        this.pageCanSubmit = true;
        let tempData = this.$refs['pageForm'].getFormDefaultData();
        tempData.lease = [{}];
        tempData['carparkID'] = this.$route.query.carparkID || tempData['carparkID'];
        tempData['licenseID'] = this.$route.query.licenseID || tempData['licenseID'];

        this.pageTitle = 'Parking License Payment Plan Change Application';
        this.pageShowData = true;
        this.$refs['pageForm'].setForm(true, tempData);

        if(this.$refs['pageForm'].formData['carparkID']) {
          this.loadLicense();
        }
      }
    },

    loadLicense() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      if(!this.$refs['pageForm'].formIsAdd) {
        url += '/api2/license/' + formData['licenseID'];
      } else {
        url += '/api2/carpark/' + formData['carparkID'] + '/license/';
      }
      
      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // TODO kw1 only show active license & lease
          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active');
          }
          this.pageLicense = response.data;

          response.data.forEach(k => {
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
          });

          helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
          this.hideFormFromKey('sectionProductSubscription');

          if(!this.$refs['pageForm'].formIsAdd) {
            formData['carparkID'] = response.data.find(k => helper.compareID(k.id, formData['licenseID']))['carparkID'];
            this.$refs['pageForm'].$forceUpdate();
            // this.loadApplicationData(formData['applicationData']);

            this.$refs['pageForm'].formData['lease'].forEach(k => k['leaseSelected'] = true);
            this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'], false);
            this.loadLicenseLease();
            return;
          }

          if(formData['licenseID'] && response.data.find(k => helper.compareID(k.id, formData['licenseID']))) {
            this.loadLicenseLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackMessage();
            formData['licenseID'] = null;
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseLease() {
      this.hideFormFromKey('sectionProductSubscription');

      this.pageSeason = null;
      this.pageParker = null;

      let feedbackItem = 'parking license lease data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license/' + this.$refs['pageForm'].formData['licenseID'] + '/lease/?current=1',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.latestLease = response.data;
          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active' && !k['stopBillDate']);
            this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'] = response.data, true);
          }
          this.loadPasscard();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadPasscard() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL + '/api2/carpark/' + formData['carparkID'] + '/passcard/';

      let feedbackItem = 'parking license passcard'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      helper.inputSelectSetOption(this.PARAM_MAP['_lease'], [].concat('All Subscription', this.$refs['pageForm'].formData['lease']));

      this.calculateParkingFees();
    },
    loadSeason() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['pageForm'].formData['carparkID'] + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.hideFormFromKey('sectionProductSubscription');

      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // if(this.pageFees[seasonID] = response.data[0]) {
            // if(this.pageFees[seasonID] = response.data.find(k => k.isActive)) {
            if(this.pageFees[seasonID] = response.data) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.calculateParkingFees();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      this.hideFormFromKey('sectionProductSubscription');

      let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']).customerID;

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + customerID + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageParker = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    calculateParkingFees() {
      let formData = this.$refs['pageForm'].formData;
      formData.lease = formData.lease || [];
      formData['applicationTotalPayable'] = 0.00;

      let tandemCalculated = {};
      formData.lease.forEach(leaseData => {
        this.$refs['pageTableLease'].removeLeaseDataSeasonField(leaseData);
      });
      this.$refs['pageTableLease'].setLeaseTotal();

      if(this.checkSeasonFees()) {
        return;
      }

      let leaseTotal = {};
      this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => leaseTotal[k] = 0);

      formData.lease.forEach(leaseData => {
        let passcard = this.pagePasscard.find(k => helper.compareID(k.id, leaseData['passcardID']));
        leaseData['leasePasscard'] = (passcard || {}).sku;
        
        let applicationPaymentPlan = parseInt(leaseData['paymentPlan']);
        if(applicationPaymentPlan === undefined || applicationPaymentPlan === null) {
          return;
        }

        let applicationCommencementDateText = leaseData['commencementDate'];
        if(applicationCommencementDateText === undefined || applicationCommencementDateText === null) {
          return;
        }

        let applicationCommencementDate = helper.parseDateTime(applicationCommencementDateText);
        let daysInMonth = applicationCommencementDate.daysInMonth();
        let startDay = applicationCommencementDate.date();

        if(leaseData['nextBillDate']) {
          let date = helper.parseDateTime(leaseData['nextBillDate']);
          leaseData['leaseNextBillingMonth'] = date ? date.format('MM/YYYY') : '';
        } else {
          let latestLeaseState = this.latestLease.find(k => k.id === leaseData['leaseID'])
          if(latestLeaseState && latestLeaseState['nextBillDate']) {
            let date = helper.parseDateTime(latestLeaseState['nextBillDate']);
            leaseData['leaseNextBillingMonth'] = date ? date.format('MM/YYYY') : '';
          }
        }

        if(leaseData['parkerID']) {
          let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
          leaseData['_parker'] = parker;
          leaseData['parkerName'] = parker['name'];
          this.$refs['pageTableLease'].setLeaseDataParker(leaseData, parker);
        } else {
          let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
          leaseData['_parker'] = parker;
          leaseData['parkerName'] = parker['name'];
          this.$refs['pageTableLease'].setLeaseDataParker(leaseData, parker);
        }
        let season = this.pageSeason.find(k => helper.compareID(k.id, leaseData['seasonID']));
        leaseData['leaseProductName'] = (season || {}).name;

        let zone = this.pageZone.find(k => helper.compareID(k.id, (season || {})['zoneID']));
        leaseData['leaseZone'] = (zone || {}).name;
        
        let product = this.pageFees[leaseData['seasonID']].find(k => helper.compareID(k.id, leaseData['seasonFees']));
        // if(!product || product.startDate > leaseData['commencementDate']) {
        if(!product) {
          product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
          if(!product) {
            for(let temp of this.pageFees[leaseData['seasonID']]) {
              if(temp.startDate <= leaseData['commencementDate']) {
                product = temp;
                break;
              }
            }
          }
        }
        if(!product) return;
        leaseData['seasonFeesID'] = product.id;

        product.feesDeposit = parseFloat(product['deposit'] || 0);
        product.feesEstablishment = parseFloat(product['establishment'] || 0);
        product.fees1Month = parseFloat(product['monthly'] || 0);
        product.fees3Month = parseFloat(product['quarterly'] || 0) * 3;
        product.fees6Month = parseFloat(product['halfYearly'] || 0) * 6;
        product.fees12Month = parseFloat(product['annually'] || 0) * 12;
        
        leaseData['commencementDate'] = applicationCommencementDate.unix();
        leaseData['commencementDateText'] = helper.formatDate(leaseData['commencementDate']);
        leaseData['paymentPlan'] = applicationPaymentPlan;

        leaseData['leaseProductDeposit'] = product.feesDeposit;
        leaseData['leaseProductEstbFee'] = product.feesEstablishment;

        switch(applicationPaymentPlan) {
          case 1:
            leaseData['paymentPlanText'] = 'Monthly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees1Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
            }
            leaseData['leaseProductParkingFee'] = product.fees1Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';
            break;
          case 2:
            leaseData['paymentPlanText'] = 'Quarterly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees3Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees3Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees3Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / quarter';
            break;
          case 3:
            leaseData['paymentPlanText'] = 'Half-yearly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees6Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees6Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees6Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / half-year';
            break;
          case 4:
            leaseData['paymentPlanText'] = 'Annually';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees12Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees12Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees12Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / annual';
            break;
        }

        leaseData['leaseProductInitialPayment'] = product.feesDeposit + product.feesEstablishment + leaseData['leaseProductInitialParkingFee'];

        this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => {
          tandemCalculated[k] = tandemCalculated[k] || [];

          let originalLease = leaseData['leaseID'] ? this.latestLease.find(k => k.id === leaseData['leaseID']) : leaseData
          if(!originalLease['pairID']) {
            leaseTotal[k] += leaseData[k];
          } else if(!tandemCalculated[k].includes(originalLease['pairID'])) {
            leaseTotal[k] += leaseData[k];
            tandemCalculated[k].push(originalLease['pairID']);
          }

          leaseData[k + 'Text'] = leaseData[k + 'Text'] || helper.formatMoney(leaseData[k]);
        });
      });

      this.$refs['pageTableLease'].setLeaseTotal(leaseTotal);
      formData['applicationTotalPayable'] = leaseTotal['leaseProductInitialPaymentText'];

      this.hideFormFromKey(null);
    },
    checkSeasonFees() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    onCancelButtonClick() {
      helper.redirect({ path: helper.WEB_URL + '/plPaymentPlanChange', query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm() && !this.validateApplicationData()) {
        if(this.$refs['pageForm'].formIsAdd) {
          this.addApplication({});
        } else {
          this.editApplication({});
        }
      }
    },
    validateApplicationData() {
      let formData = this.$refs['pageForm'].formData;
      let hasSelected = false;
      if(!formData.lease.find(k => k.leaseSelected)) {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('Please select at least one subscription to proceed');
        $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
        return true;
      }

      // TODO kw1 validate refund method field
    },
    
    addApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      formData['lease'].forEach(j => j['parkerID'] = (this.pageParker.find(k => helper.compareID(k.id, j['parkerID'])) || {}).id)

      let temp = {}
      temp['carparkID'] = formData['carparkID'];
      temp['paymentPlan'] = formData['paymentPlan'];
      temp['applicationStaff'] = formData['applicationStaff'];
      temp['operatorID'] = this.pageCarpark.find(k => helper.compareID(k.id, formData['carparkID'])).operatorID;
      temp['leases'] = JSON.stringify(formData['lease'].filter(k => k.leaseSelected));

      let feedbackItem = 'parking license payment plan change application';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePaymentPlanChange/create',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + feedbackItem);
          // this.onApproveButtonClick();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    editApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      let temp = {}
      temp['paymentPlan'] = formData['paymentPlan'];
      temp['applicationStaff'] = formData['applicationStaff'];
      temp['leases'] = JSON.stringify(formData['lease']);

      let feedbackItem = 'parking license payment plan change appplication';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          helper.API_URL + '/api2/licensePaymentPlanChange/update',
          querystring.stringify(temp),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      helper.redirect({ path: helper.WEB_URL + '/plPaymentPlanChange', query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'carparkID') {
        formData['licenseID'] = null;
        formData['_lease'] = [];
        formData['lease'] = [];
        this.loadLicense();
      } else if(formParameter.key === 'licenseID') {
        formData['_lease'] = [];
        formData['lease'] = [];
        this.loadLicenseLease();
      } else if(formParameter.key === '_lease') {
        formData['lease'].forEach(k => {
          if(formData['_lease'].includes('All Subscription')) {
            k.leaseSelected = true;
          } else {
            k.leaseSelected = formData['_lease'].includes('' + k.id);
          }
        });

        // if one tandem is selected, the pair/group must select together
        if(!formData['_lease'].includes('All Subscription')) {
          formData['lease'].forEach(k => {
            if(k.leaseSelected && k.pairID) {
              formData['lease'].forEach(j => {
                if(j.pairID === k.pairID) {
                  j.leaseSelected = true;
                }
              });
            }
          });
        }

        this.$refs['pageTableLease'].$forceUpdate();
        this.onLeaseOrPaymentPlanSelected();
        this.calculateParkingFees();
      } else if(formParameter.key === 'paymentPlan') {
        this.onLeaseOrPaymentPlanSelected();
      } else if(formParameter.key === 'terminationRefundMethod') {
        this.hideFormFromKey(null);
      } else if(formParameter.key === 'applicationStaff') {
        this.onApplicationStaffChange();
      }
    },
    onLeaseOrPaymentPlanSelected() {
      this.$refs['pageForm'].$refs['jt-form-element-paymentPlan'][0].setInputError();

      let formData = this.$refs['pageForm'].formData;
      let selectedLease = formData['lease'].filter(k => k.leaseSelected);
      if(selectedLease.length !== 1) {
        return;
      }

      if(helper.compareID(selectedLease[0]['paymentPlan'], formData['paymentPlan'])) {
        formData['paymentPlan'] = null;
        // this.hideFormFromKey('applicationStaff');
        this.$refs['pageForm'].$refs['jt-form-element-paymentPlan'][0].setInputError('Selected payment plan same as the current payment plan, please select other payment plan.');
        $(document).scrollTop($('#jt-form-div-paymentPlan')[0].offsetTop);
      }
    },
    onApplicationStaffChange() {
      let staff = helper.inputSelectFindOption(this.PARAM_MAP['applicationStaff'], this.$refs['pageForm'].formData['applicationStaff']) || {}
      this.$refs['pageForm'].formData['applicationStaffNo'] = staff['personnelCode'];
    },

    onApproveButtonClick() {
      this.updateApplicationStatus('approve');
    },
    onCompleteButtonClick() {
      this.updateApplicationStatus('complete');
    },
    updateApplicationStatus(action) {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = 'parking license payment plan change application status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licensePaymentPlanChange/' + action,
          querystring.stringify({ leases: JSON.stringify(formData['lease']) }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },

    hasAddOrEditPermission() {
      return this.pageIsAdd ? helper.hasAddPermission(this.permission) : helper.hasEditPermission(this.permission);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLPaymentPlanChangeForm.vue